import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../../console/store/useAuthStore";
import useToastStore from "../../../../../console/store/useToastStore";
import { enum_api_uri } from "../../../utils/enum";

interface PutCategoryRequest {
    categoryIdx: number | null;
    category_name: string;
    wreath_option: boolean;
    union_option: boolean;
    category_image?: File | null;
    del_image: boolean;
}

interface ApiResponse {
    status: string;
    message: string;
}

export const usePutGoodsCategoryInfo = (successCallback?: () => void) => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);
    const { addToast } = useToastStore();

    return useMutation<ApiResponse, Error, PutCategoryRequest>({
        mutationFn: async (data: PutCategoryRequest) => {
            const formData = new FormData();

            formData.append("category_name", data.category_name);
            formData.append("wreath_option", data.wreath_option.toString());
            formData.append("union_option", data.union_option.toString());

            if (data.category_image instanceof File) {
                formData.append("category_image", data.category_image);
            }
            formData.append("image_del", data.del_image.toString());

            const response = await axios.put(`${enum_api_uri.put_product_category}/${data.categoryIdx}`, formData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getGoodsCategory"] });
            queryClient.invalidateQueries({ queryKey: ["getGoodsCategoryInfo"] });
            queryClient.invalidateQueries({ queryKey: ["getGoodsList"] });
            queryClient.invalidateQueries({ queryKey: ["getGoodsInfo"] });
            addToast({
                message: "해당 카테고리가 변경되었습니다.",
                type: "success",
            });
            successCallback?.();
        },
    });
};
